export default "__VITE_ASSET__DNt5LK3S__"